import './index.css'
import cn from 'clsx'
import * as React from 'react'
import { MdError as ErrorIcon } from '@react-icons/all-files/md/MdError'
type OwnProps = {
  children?: React.ReactNode
  // TODO: make `children` required and drop `note`
  note?: React.ReactNode
  // DEPRECATED: `note` is deprecated in favor of `children`
  className?: string
  displayIcon?: boolean
}

/**
 * A component for displaying form notes or help text with an optional error icon
 * @param children - The note content to display (preferred over note prop)
 * @param note - The note content to display (deprecated, use children instead)
 * @param className - Additional CSS classes to apply
 * @param displayIcon - Whether to display the error icon (defaults to true)
 * @returns A div containing the note text with optional error icon
 */
const FormNote = ({
  children,
  note,
  className,
  displayIcon,
}: OwnProps): React.ReactElement<'div'> => {
  return (
    <div className={cn('form-note', className)}>
      <span className="form-note__icon">{displayIcon && <ErrorIcon />}</span>{' '}
      {note || children}
    </div>
  )
}

FormNote.defaultProps = {
  displayIcon: true,
}
export default FormNote
